/* eslint-disable no-useless-constructor, no-empty-function, no-param-reassign */
function callLegacy(method, ...args) {
  if (typeof $ !== 'undefined' && typeof $[method] === 'function') {
    $[method](...args);
  }
}

/**
 * TODO:
 *
 * Wrapper for the current sound manager. Should be rewritten
 * at some point.
 */
class SoundManager {
  constructor() {}

  load(...args) {
    callLegacy('loadSounds', ...args);
  }

  play(...args) {
    callLegacy('playSound', ...args);
  }

  playEffect(url, options, preventStopSounds) {
    options = Object.assign({
      mix: true,
      volume: Smartfm.Apps.Settings.EffectVolume,
    }, options);

    callLegacy('playSound', url, options, preventStopSounds);
  }

  stop(sound) {
    if (sound) {
      callLegacy('pauseSound', sound);
    } else {
      callLegacy('stopSounds');
    }
  }
}

export default new SoundManager();
